import React, { Component } from 'react';
import { instanceOf } from 'prop-types';
import PropTypes from 'prop-types';
import locale from './lang/locale.json';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute'
import { Route } from 'react-router-dom';
import s from './components/Layout/Layout.css';
import NewUser from './routes/contacts/NewUser'
import Login from './routes/login/Login'
import Message from "./routes/message/Message"
import Sent from "./routes/sent/Sent"
import Templates from "./routes/templates/Templates"
import NewTemplate from "./routes/templates/NewTemplate"
import EditTemplate from "./routes/templates/EditTemplate"
import Contacts from "./routes/contacts/Contacts"
import User from "./routes/contacts/User"
import RenameUser from "./routes/contacts/RenameUser"
import Groups from "./routes/groups/Groups"
import NewGroup from "./routes/groups/NewGroup"
import Users from "./routes/groups/Users"
import RenameGroup from "./routes/groups/RenameGroup"
import BatchInfo from "./routes/sent/BatchInfo"
import { withCookies, Cookies } from 'react-cookie';

class App extends Component {
    static propTypes = {
        numbers: PropTypes.arrayOf(PropTypes.string),
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            logged: null,
            username: props.username,
            numbers: []
        };
    }

    componentDidMount() {
        this.setState({
            username: sessionStorage.getItem("username"),
        })
    }

    render() {
        let cookieToken = this.props.cookies.get("authenticationtoken");
        let sessionToken = sessionStorage.getItem("authenticationtoken");
        let isLoggedIn = cookieToken != undefined;
        if (isLoggedIn && cookieToken != sessionToken) {
            sessionStorage.setItem('username', this.props.cookies.get("username"));
            sessionStorage.setItem('senders_list', JSON.stringify(this.props.cookies.get("senders_list")));
            sessionStorage.setItem('default_sender', this.props.cookies.get("default_sender"));
            sessionStorage.setItem('userType', this.props.cookies.get("userType"));
            sessionStorage.setItem("authenticationtoken", cookieToken);
        }
        return (
            <div>
                {isLoggedIn ?
                    <Header
                        locale={locale.Header}
                        username={this.state.username}
                    />

                    :
                    <div />
                }
                <div className={s.main}>
                    {isLoggedIn ?
                        <Sidebar locale={locale.Navigation} />
                        :
                        ""
                    }
                    <section className={s.content_wrapper}>
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/" component={Message} locale="Message" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/message" component={Message} locale="Message" />
                        <Route exact path="/api" render={() => { window.location.replace('https://adstod.siminn.is/home/sms-magnsendingar-api'); return null; }} />

                        <PrivateRoute isLoggedIn={isLoggedIn} path="/sent" component={Sent} locale="Sent" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/sent/:id" component={BatchInfo} locale="Sent" />

                        <PrivateRoute isLoggedIn={isLoggedIn} path="/templates" component={Templates}
                            locale="Templates" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/add_new_template" component={NewTemplate}
                            locale="NewTemplate" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/templates/:id" component={EditTemplate}
                            locale="EditTemplate" />

                        <PrivateRoute isLoggedIn={isLoggedIn} path="/contacts" component={Contacts} locale="Contacts" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/contacts/:id" component={User} locale="User" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/contacts/:id/rename_user" component={RenameUser}
                            locale="RenameUser" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/add_new_contact" component={NewUser}
                            locale="AddContact" />

                        <PrivateRoute isLoggedIn={isLoggedIn} path="/groups" component={Groups} locale="Groups" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/add_new_group" component={NewGroup}
                            locale="NewGroup" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/groups/:id" component={Users} locale="Users" />
                        <PrivateRoute isLoggedIn={isLoggedIn} path="/groups/:id/rename_group" component={RenameGroup} locale="RenameGroup" />

                        <PrivateRoute isLoggedIn={isLoggedIn} path="/login" component={Login} locale="Login" />
                    </section>
                </div>
            </div>
        );
    }
}

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/App.js